// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import markerPin03Icon from "@/assets/icons/marker-pin-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MarkerPin03IconProps = Omit<IconProps, "name">;

export function MarkerPin03Icon(props: MarkerPin03IconProps): React.ReactNode {
  return <Icon name={markerPin03Icon} {...props} />;
}
